// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__ogIF0","content":"GlobalSearch_content__1T9y2"};